module.exports = __webpack_public_path__ + "static/media/EXPORT_BULK_UPLOAD_ATHENA_WITH_VAT_PARTNER.292e2e00.xlsx";